import { render, staticRenderFns } from "./JobCarDeliveryInfo.vue?vue&type=template&id=70867be9"
import script from "./JobCarDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./JobCarDeliveryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports